import { SelectHelperMenuItem, useLocale } from 'bold-ui'
import { SelectField } from 'components/form'
import {
  AsyncSelectFieldProps,
  DEFAULT_SELECT_PAGE_PARAM,
  useAsyncQuerySelect,
} from 'components/form/field/select/useAsyncQuerySelect'
import { LoteImunobiologicoFabricanteDocument } from 'graphql/hooks.generated'
import { LoteImunobiologicoFabricanteQuery, LoteImunobiologicoFabricanteQueryVariables } from 'graphql/types.generated'
import React from 'react'

export type LoteImunobiologicoFabricanteSelectFieldModel = Partial<
  LoteImunobiologicoFabricanteQuery['fabricantesImunobiologico']['content'][0]
>

export function LoteImunobiologicoFabricanteSelectField(
  props: AsyncSelectFieldProps<LoteImunobiologicoFabricanteSelectFieldModel>
) {
  const {
    selectProps: { loading, ...asyncProps },
    skipping,
  } = useAsyncQuerySelect<
    LoteImunobiologicoFabricanteSelectFieldModel,
    LoteImunobiologicoFabricanteQuery,
    LoteImunobiologicoFabricanteQueryVariables
  >({
    query: LoteImunobiologicoFabricanteDocument,
    extractItems: (data) => data?.fabricantesImunobiologico?.content,
    variables: (inputQuery: string) => ({
      input: {
        query: inputQuery,
        pageParams: {
          page: {
            ...DEFAULT_SELECT_PAGE_PARAM,
            size: 5,
            sort: ['nome'],
          },
        },
      },
    }),
    fetchPolicy: 'cache-first',
    skip: (inputString) => inputString?.trim()?.length < 2,
  })

  const itemToString = (item: LoteImunobiologicoFabricanteSelectFieldModel) => item?.nome

  return (
    <SelectField<LoteImunobiologicoFabricanteSelectFieldModel>
      itemToString={itemToString}
      components={{ EmptyItem: () => EmptyMenuItem({ skipping }) }}
      {...asyncProps}
      {...props}
    />
  )
}

const EmptyMenuItem = ({ skipping }: { skipping: boolean }) => {
  const locale = useLocale()

  return (
    <SelectHelperMenuItem>
      {skipping ? 'Digite para buscar um fabricante.' : locale.select.emptyItem}
    </SelectHelperMenuItem>
  )
}
